import {cva} from 'class-variance-authority'

/**
 * Tab (v3, MUI-aligned flat API). A single tab button. The active tab uses the
 * brand (primary) text color plus a primary underline indicator; inactive tabs
 * use the default text color.
 *
 * Hover and press are a full-bleed brand overlay (`action-hover` at 32%,
 * `action-focus` at 16%) rather than a text-color shift — matching Figma, where
 * both the active and inactive tabs keep their own text color throughout.
 */
export const TabVariantsFactory = cva(
  'relative inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap px-4 py-[9px] font-sans text-[16px] font-bold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-inset disabled:cursor-not-allowed [&_svg]:size-6 [&_svg]:shrink-0',
  {
    variants: {
      active: {
        true: 'text-primary',
        false: 'text-text-primary',
      },
      disabled: {
        // Disabled tabs opt out of the interaction overlay entirely.
        true: 'text-text-disabled',
        false: 'hover:bg-action-hover active:bg-action-focus',
      },
      fullWidth: {
        true: 'flex-1',
        false: '',
      },
    },
    defaultVariants: {
      active: false,
      disabled: false,
      fullWidth: false,
    },
  },
)
